import React, { useEffect, useState } from 'react';
import { Label } from 'reactstrap';
import {
  CLICK_ACTIONS,
  DEFAULT_PAGE_SIZE,
  EMP_DETAILS_TYPE,
} from '../../../utils/Constant';
import {
  ApiResponseStatusType,
  ColumnHeaderType,
  EmployeeInformationFilterType,
  EmployeeListItemType,
  PaginationType,
  SelectOptionType,
} from '../../../utils/Types';
import { useAppDispatch, useAppSelector } from '../../../store/redux-hooks';
import KTable from '../../../components/KTable';
import KPagination from '../../../components/KPagination';
import CenterSpinner from '../../../components/CenterSpinner';
import EmployeeInformationFilter from '../../../filters/EmployeeInformationFilter';
import EmployeeInformationModal from '../../modals/EmployeeInformationModal';
import {
  employeeDataSelector,
  fetchAllEmployeeList,
  fetchEmployeeStatusDrops,
} from '../../../features/employeeDataSlice';
import RoleModal from '../../../components/RoleModal';
import { locationFilterSelector } from '../../../features/locationFilterSlice';
import { getEmpDateReqParam, onRoleUpdate, updateRole } from './EmployeeHelper';
import { requestCities } from '../../attendance/ViewAttendeesPageHelper';
import { useLoader } from '../../../loader/LoaderProvider';
interface IEmployeeDetails {
  detailType: string;
  columnsHeder: any[];
  title: string;
}
const EmployeeDetails: React.FunctionComponent<IEmployeeDetails> = ({
  detailType,
  columnsHeder,
  title,
}) => {
  const { showLoader, setShowLoader } = useLoader();
  const [isInfoModalOpen, setIsInfoModalOpen] = useState<boolean>(false);
  const [isRoleModal, setIsRoleModal] = useState<boolean>(false);
  const [pageSize, setPageSize] = useState<number>(DEFAULT_PAGE_SIZE);
  const [selectedEmployee, setSelectedEmployee] =
    useState<EmployeeListItemType | null>();
  const [selectedFilter, setSelectedFilter] =
    useState<EmployeeInformationFilterType>();
  const [currentPage, setCurrentPage] = useState<number>(1);
  const roleUpdateStatus: ApiResponseStatusType =
    useAppSelector(employeeDataSelector).roleUpdateStatus;
  const employeeList: EmployeeListItemType[] =
    useAppSelector(employeeDataSelector).employeeList;
  const pagination: PaginationType =
    useAppSelector(employeeDataSelector).pagination;
  const dispatch = useAppDispatch();
  const locationData = useAppSelector(locationFilterSelector);

  const onTableAction = (item: any, headerItem: ColumnHeaderType) => {
    if (
      headerItem.action === CLICK_ACTIONS.VIEW_TASK ||
      headerItem.action === CLICK_ACTIONS.VIEW_ROLE_DETAILS
    ) {
      setSelectedEmployee(item);
      setIsInfoModalOpen(true);
    } else if (headerItem.action === CLICK_ACTIONS.EDIT_ROLES) {
      setSelectedEmployee(item);
      setIsRoleModal(true);
    }
  };
  const findEmployeeList = (selectedFilter?: EmployeeInformationFilterType) => {
    setShowLoader(true);
    dispatch(
      fetchAllEmployeeList(
        getEmpDateReqParam(currentPage, pageSize, selectedFilter)
      )
    );
  };
  const toggleEmployeeInfoModal = (action: string) => {
    if (action === CLICK_ACTIONS.REFRESH_LIST) {
      findEmployeeList(selectedFilter);
    }
    setIsInfoModalOpen(false);
  };
  useEffect(() => {
    requestCities(employeeList, locationData, dispatch);
  }, [employeeList]);
  useEffect(() => {
    onRoleUpdate(
      roleUpdateStatus,
      selectedFilter,
      setShowLoader,
      findEmployeeList
    );
  }, [roleUpdateStatus]);
  useEffect(() => {
    setShowLoader(false);
  }, [employeeList]);
  useEffect(() => {
    findEmployeeList(selectedFilter);
  }, [pageSize, currentPage, selectedFilter]);

  useEffect(() => {
    dispatch(fetchEmployeeStatusDrops());
  }, []);
  return (
    <div className="ml-4">
      <Label className="text-heading">{title}</Label>
      <EmployeeInformationFilter
        onApplyFilters={(filter: EmployeeInformationFilterType) => {
          setSelectedFilter(filter);
          setCurrentPage(1);
        }}
      />
      <div className="mt-4">
        <KTable
          data={employeeList}
          tableParentClass="table-parent-view-task"
          columnHeader={columnsHeder}
          onAction={onTableAction}
          isLoading={showLoader}
        />
        {employeeList && employeeList.length > 0 && (
          <KPagination
            currentPage={pagination?.currentPage}
            pageSize={pageSize}
            onPageChange={setCurrentPage}
            onSizeChange={setPageSize}
            fromItem={pagination?.fromItem}
            toItem={pagination?.toItem}
            totalItems={pagination?.totalItems}
          />
        )}
      </div>

      {isInfoModalOpen && (
        <EmployeeInformationModal
          isOpen={isInfoModalOpen}
          candidateId={Number(selectedEmployee?.candidateId)}
          toggleModal={toggleEmployeeInfoModal}
          readOnly={detailType === EMP_DETAILS_TYPE.DATA}
        />
      )}
      {isRoleModal && (
        <RoleModal
          isOpen={isRoleModal}
          previousRoles={selectedEmployee?.roles}
          updateRole={(roles: SelectOptionType[]) =>
            updateRole(
              roles,
              selectedEmployee,
              setShowLoader,
              dispatch,
              setSelectedEmployee,
              setIsRoleModal
            )
          }
          toggle={() => {
            setIsRoleModal(false);
          }}
        />
      )}

      <CenterSpinner showLoader={showLoader} className="spinner-60" />
    </div>
  );
};

export default EmployeeDetails;
